module.exports = __webpack_public_path__ + "static/img/image_placeholder.ebe9884.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image_placeholder.jpg
// module id = 158
// module chunks = 31